/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
namespace dvs_ui {

   import DvsPortMirroringSpec =
         com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.DvsPortMirroringSpec;
   import DvsPortMirroringData =
         com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.DvsPortMirroringData;
   import IPromise = angular.IPromise;

   export class DvsPortMirroringComponentService {

      public static readonly $inject = ["dataService",
         "vxPropertyViewService"];

      private static readonly PORT_MIRRORING_DATA_PROPERTY_NAME: string =
            "dvswitchportmirroring:portMirroringDetails";

      private static readonly PORT_MIRRORING_CAPABILITY =
            "dvswitchportmirroring:isAnySpanSessionSupported";

      constructor(private dataService: any) {

      }

      public getDvsPortMirroringData(dvsUrn: string):IPromise<DvsPortMirroringData> {

         return this.dataService
               .getProperties(dvsUrn, [DvsPortMirroringComponentService
                     .PORT_MIRRORING_DATA_PROPERTY_NAME])
               .then((response: any) => {
                  return response ? response[DvsPortMirroringComponentService
                        .PORT_MIRRORING_DATA_PROPERTY_NAME] : null;
               });

      }

      public getDvsPortMirroringCapability(dvsUrn: string):IPromise<Boolean> {

         return this.dataService
               .getProperties(dvsUrn, [DvsPortMirroringComponentService
                     .PORT_MIRRORING_CAPABILITY])
               .then((response: any) => {
                  return response ? response[DvsPortMirroringComponentService
                        .PORT_MIRRORING_CAPABILITY] : false;
               });
      }
   }

   angular.module("com.vmware.vsphere.client.dvs")
         .service("dvsPortMirroringComponentService",
               DvsPortMirroringComponentService);
}
